import { useMutation } from '@apollo/react-hooks'
import { Button, Collapse, FormSection, FormSectionTitle, Typography } from '@paintscout/ui'
import React, { useState } from 'react'
import { gql } from 'apollo-boost'
import { useFormikContext } from 'formik'
import { makeStyles } from '@material-ui/core/styles'
import type { ClientMetaDocument, OptionsDocument } from 'paintscout'

const useStyles = makeStyles((theme) => ({
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  buttonGroup: {
    display: 'flex',
    gap: theme.spacing(2)
  },
  resultContainer: {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper
  },
  error: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(2)
  },
  pre: {
    margin: 0,
    fontSize: '0.875rem',
    fontFamily: 'monospace',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word'
  }
}))

export default function ClientHubSpotSync() {
  const classes = useStyles()
  const {
    values: { meta }
  } = useFormikContext<{ meta: ClientMetaDocument; options: OptionsDocument }>()
  const companyId = meta._id

  const [syncedData, setSyncedData] = useState<any>(null)
  const [error, setError] = useState<string | null>(null)

  const [syncCompanyData, { loading }] = useMutation(gql`
    mutation syncCompanyData($companyId: String!, $preview: Boolean) {
      syncCompanyData(companyId: $companyId, preview: $preview)
    }
  `)

  const handleClick = (preview: boolean) => {
    setSyncedData(null)
    setError(null)
    syncCompanyData({ variables: { companyId, preview } })
      .then((response) => {
        console.log(response)
        setSyncedData(response.data.syncCompanyData)
      })
      .catch((error) => {
        console.log(error)
        setError(error.message)
      })
  }

  return (
    <>
      <FormSectionTitle title="HubSpot" />
      <FormSection className={classes.section}>
        <div className={classes.buttonGroup}>
          <Button onClick={() => handleClick(true)} loading={loading}>
            Preview Data
          </Button>
          <Button onClick={() => handleClick(false)} loading={loading}>
            Send Data to HubSpot
          </Button>
        </div>
        <Collapse show={!!syncedData && !error}>
          <div className={classes.resultContainer}>
            <Typography variant="h4" gutterBottom>
              Data:
            </Typography>
            <pre className={classes.pre}>{JSON.stringify(syncedData, null, 2)}</pre>
          </div>
        </Collapse>
        <Collapse show={!!error}>
          <Typography className={classes.error}>
            <strong>Error:</strong> {error}
          </Typography>
        </Collapse>
      </FormSection>
    </>
  )
}
